import { useGetUsersMeQuery } from 'src/services/usersService';
import { ROLES } from 'src/constants/roles';

// Whether the signed-in user is a CoSupport manager (false until their profile loads).
export const useIsCosupportManager = (): boolean => {
  const { data: userInfo } = useGetUsersMeQuery();

  return userInfo?.role === ROLES.COSSUPORT_MANAGER;
};
